<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Select <br>Project Gate
      </h1>
      <br>
      <p class="subheader-style">
        Select a project gate through you want to check-in.
      </p>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <div
        v-if="!isProjectGatesAvailable"
        class="empty-alert-div"
      >
        <v-card
          elevation="0"
          color="#E6E6E6"
          class="check-in-history"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No project gates found
          </p>
          <br>
          <br>
        </v-card>
      </div>
      <template v-for="(item, i) in organizationProjectGates">
        <v-col
          :key="i"
          cols="12"
          md="12"
        >
          <div
            class="select-list-style"
            @click="toSelectedProcess(item)"
          >
            {{ item.name }}
          </div>
        </v-col>
      </template>
      <center-spinner
        :loading="loading"
      />
    </div>
  </v-dialog>
</template>

<script>
  import spinner from '../../../components/SpinnerCentre.vue';
  export default {
  name: 'SelectProjectGate',
  components: {
    'center-spinner': spinner,
  },
  data: () => ({
    loading: false,
    showModal: true,
  }),
  computed: {
    organizationProjectGates () {
      return this.$store.getters['projects/getOrganizationProjectGates'];
    },
    selectedOrgProject () {
      return this.$store.getters['projects/getSelectedOrgProject'];
    },
    isProjectGatesAvailable () {
      if (this.organizationProjectGates.length > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    await this.getOrganizationProjectGates();
  },
  methods: {
    async getOrganizationProjectGates () {
      this.loading = true;
      const projectId = this.selectedOrgProject.id;
      await this.$store.dispatch('projects/fetchOrganizationProjectGates', {
        projectId: projectId,
      }).catch(() => {
        this.loading = false;
      });
      this.loading = false;
    },
    toSelectedProcess (item) {
      this.loading = true;
      this.$store.dispatch('projects/selectedOrgProjectGate', item);
      setTimeout(() => {
        this.$emit('project-gate-selected');
        this.loading = false;
      }, 1000);
    },
  },
};
</script>
